import { PaymentMethod } from '../schema/payment'

const normalizePaymentMethod = (paymentMethod: PaymentMethod) => {
  switch (paymentMethod) {
    case 'mastercard':
    case 'visa':
      return 'creditcard'
    default:
      return paymentMethod
  }
}

export default normalizePaymentMethod
